 import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import SystemField from '@/common/constant/SystemField';
import { uploadTicketFileToS3 } from '@/service/ticketService';
import { cloneDeep } from 'lodash';

/**
 * permissionCreateQATicketByGuestUser
 * guest contract QA to helpdesk invite
 * @param {*} userDetail 
 * @param {*} projectInuseDetail 
 * @returns 
 */
export const permissionCreateQATicketByGuestUser = (
    userDetail,
    projectInuseDetail
) => {
    if (Utils.isProjectGuest(projectInuseDetail)) {
        return (
            Utils.isGuestUser(userDetail)
        );
    }
    if (Utils.isProjectGuestDesk(projectInuseDetail)) {
        return false;
    }
    return false;
};

export const getFormFieldData = (formStructure, fieldList) => {
    let formData = [];

    if (!Utils.isEmptyObject(formStructure)) {
        for (const fieldNumber in formStructure) {
            if (formStructure.hasOwnProperty(fieldNumber)) {
                let fieldData = {};
                let fieldId = '';
                let formField = formStructure[fieldNumber];

                if (
                    formStructure[fieldNumber].hasOwnProperty('field') &&
                    !Utils.isEmptyArray(fieldList)
                ) {
                    fieldId = formStructure[fieldNumber]['field'];
                    fieldData = fieldList.find((customField) => customField.id === fieldId);
                    if(fieldData){
                        if (Utils.isJson(fieldData.structure)) fieldData.structure = JSON.parse(fieldData.structure);
                    }
                } else if (
                    formStructure[fieldNumber].hasOwnProperty('sysfield') &&
                    !Utils.isEmptyArray(SystemField)
                ) {
                    fieldId = formStructure[fieldNumber]['sysfield'];
                    fieldData = SystemField.find((systemField) => systemField.id === fieldId);
                }

                if (!Utils.isEmptyObject(fieldData)) {
                    fieldData.fieldId = fieldId;
                    fieldData.fieldLabel = fieldData.name;
                    fieldData.structure.required = formField.required;
                    fieldData.structure.publicForCustomer = formField.publicForCustomer;
                    formData.push(fieldData);
                }
            }
        }
    }

    return formData;
};

/**
 * check permission create ticket invite guest desk
 * @param {*} isProjectManagerByProject
 * @param {*} userDetail
 * @param {*} selectedProjectType
 * @param {*} formInviteGuestDeskStatus
 * @param {*} numOfGuestDeskProject
 * @param {*} contractType
 * @returns status
 */
export const permissionCreateTicketInviteGuestDesk = (
    userDetail,
    selectedProjectType,
    formInviteGuestDeskStatus,
    numOfGuestDeskProject,
    contractType,
    maxNumOfGuestDesk
) => {
    let maxNumberOfGuestDesk = maxNumOfGuestDesk || Constant.CORPORATION_CONTRACT.DATA.DEFAULT_MAX_NUM_OF_GUEST_DESK_PROJECT;
    return (
        Utils.isGeneralUserWithoutGuest(userDetail) &&
        selectedProjectType === Constant.PROJECT_TYPE.GENERAL &&
        formInviteGuestDeskStatus &&
        numOfGuestDeskProject < maxNumberOfGuestDesk &&
        contractType === Constant.CORPORATION_CONTRACT_TYPE.PREMIUM
    );
};

/**
 * check permission create external desk request ticket
 * @param {*} userDetail
 * @param {*} selectedProjectType
 * @param {*} formInviteExternalDeskRequestStatus
 * @param {*} contractType
 * @returns
 */
export const permissionCreateTicketExternalDeskRequest = (
    userDetail,
    selectedProjectType,
    formInviteExternalDeskRequestStatus,
    contractType,
) => {
    return (
        Utils.isGeneralUserWithoutGuest(userDetail) &&
        selectedProjectType === Constant.PROJECT_TYPE.GENERAL &&
        formInviteExternalDeskRequestStatus &&
        contractType === Constant.CORPORATION_CONTRACT_TYPE.PREMIUM
    );
};

/**
 * permissionCreateTicketKnowledge
 * @param {*} organizationProject
 * @param {*} userPermissionView 
 * @returns status
 */
export const permissionCreateTicketKnowledge = (organizationProject) => {
    return organizationProject?.value === Constant.KNOWLEDGE_VIEW_OPTION.PRJ_IN_USE
};

export const permissionCreateQATicket = (ticketListType, userDetail, projectInuseDetail) => {
    return (
        ticketListType === Constant.MENU_SELECT_TYPE.TICKET_LIST_CUSTOMER_SIDE &&
        (isCreateInternalQATicket(userDetail, projectInuseDetail) || isCreateExternalQATicket(userDetail, projectInuseDetail) || isCustomerOfCorpQA(userDetail, projectInuseDetail) || permissionCreateQATicketByGuestUser(userDetail, projectInuseDetail))
    )
}

/**
 * isCreateInternalQATicket (QA in org)
 * @param {*} userDetail 
 * @returns status
 */
export const isCreateInternalQATicket = (userDetail, projectInuseDetail) => {
     let permissionCreate =
         (userDetail.type === Constant.USER_TYPE.INTERNAL &&
            projectInuseDetail.type === Constant.PROJECT_TYPE.BASE) ||
         (Utils.isGeneralUserWithoutGuest(userDetail) &&
             [
                 Constant.PROJECT_TYPE.BASE,
                 Constant.PROJECT_TYPE.GENERAL
             ].includes(projectInuseDetail.type));
     return permissionCreate;
 };

/**
 * isCreateExternalQATicket (QA outside org)
 * @param {*} userDetail 
 * @returns status
 */
export const isCreateExternalQATicket = (userDetail, projectInuseDetail) => {
    let permissionCreate =
        Utils.isGeneralUserWithoutGuest(userDetail) &&
        projectInuseDetail.type === Constant.PROJECT_TYPE.GENERAL
    return permissionCreate;
};

/**
 * isCustomerOfCorpQA
 * @param {*} userDetail 
 * @returns 
 */
export const isCustomerOfCorpQA = (userDetail, projectInuseDetail) => {
    return (
        projectInuseDetail.type === Constant.PROJECT_TYPE.CUSTOMER &&
        userDetail.type === Constant.USER_TYPE.CUSTOMER
    );
};

/**
 * getListKnowledgeFormOfProject
 * @param {*} formList 
 * @param {*} projectId 
 * @returns  form list
 */
export const getListKnowledgeFormOfProject = (formList, projectId, corporationDetail) => {
    if (Utils.isEmptyArray(formList) || !projectId) {
        return [];
    }

    const listKnowledgeForm = formList
        .filter(
            form =>
                form.type === Constant.FORM_TYPE.FORM_KNOWLEDGE &&
                form.usingProjects.includes(projectId)
        )
        .filter(form => {
            if(Utils.isSystemBusinessAppForm(form)) return true;

            if(!Utils.isCorporationOnKnowledge(corporationDetail)) return false;

            return !(
                (Utils.isSystemAIAutoForm(form) &&
                    !Utils.isCorporationOnAIAuto(corporationDetail)) ||
                (Utils.isSystemSDAutoForm(form) && !Utils.isCorporationOnSDAuto(corporationDetail))
            );
        });

    return listKnowledgeForm;
};

export const getListMasterKnowledgeFormOfProject = (formList, projectId, corporationDetail) => {
    if (Utils.isEmptyArray(formList) || !projectId) {
        return [];
    }

    const listMasterKnowledgeForm = formList.filter(
        form =>
            form.type === Constant.FORM_TYPE.FORM_MASTER &&
            form.isProjectInuse &&
            Utils.isCorporationOnKnowledge(corporationDetail)
    );
    return listMasterKnowledgeForm;
};

export const getListSynonymKnowledgeFormOfProject = (formList, projectId) => {
    if (Utils.isEmptyArray(formList) || !projectId) {
        return [];
    }

    const listMasterKnowledgeForm = formList.filter(form =>form.isSynonym && form.isProjectInuse);
    return listMasterKnowledgeForm;
}

/**
 * handleUploadFilesForTicket
 * @param {*} API 
 * @param {*} formData 
 * @param {*} newTicket 
 * @param {*} setIsModalUploadFileError 
 * @param {*} setFileUploading 
 * @returns 
 */
export const handleUploadFilesForTicket = async (
    formData,
    setFileUploading,
    fileUploadListState,
    fileUploaded
) => {
    formData = cloneDeep(formData);
    let fileUploadList = [];
    
    if (formData.fileUploadList && !Utils.isEmptyArray(formData?.fileUploadList)) {
        fileUploadList = formData?.fileUploadList;
    } else if (fileUploadListState && !Utils.isEmptyArray(fileUploadListState)) {
        fileUploadList = fileUploadListState;
    }
    let resUpload = {
        fileListSuccess: [],
        suffixOfAttachments: {},
        listFileError: [],

    }

    if (fileUploadList?.length > 0) {
        resUpload = await uploadTicketFileToS3(
            formData,
            setFileUploading,
            fileUploaded
        );
    }

    return resUpload;
};


export const copyFileOfTicketDraftTo =  (fileList) => {
    if (!fileList || Utils.isEmptyArray(fileList)) return [];
    let listFileUploadSuccess = [];
    let suffixOfAttachments = {};
    let newFileList = cloneDeep(fileList);
    newFileList?.forEach(fileInfo => {
        if (!fileInfo.isDelete) {
            delete fileInfo.thumbnailInfo;
            const lastDot = fileInfo?.fileName?.lastIndexOf('.');
            const fileExtension = fileInfo?.fileName?.substring(lastDot + 1).toLowerCase();
            if (Utils.isEmpty(suffixOfAttachments[`${fileExtension}`])) {
                suffixOfAttachments[`${fileExtension}`] = 0;
            } else {
                suffixOfAttachments[`${fileExtension}`] += 1;
            }
            listFileUploadSuccess.push(fileInfo);
        }
    });

    return listFileUploadSuccess;
};

export const createDataListFileDuplicate = fileList => {
    if (!fileList || Utils.isEmptyArray(fileList))
        return {
            suffixOfAttachments: {},
            listFileUploadSuccess: []
        };

    let listFileUploadSuccess = [];
    let suffixOfAttachments = {};
    let newFileList = cloneDeep(fileList);
    newFileList?.forEach(fileInfo => {
        if (!fileInfo.isDelete) {
            let oldFileExtension = fileInfo?.fileName.split('.').pop();
            if (suffixOfAttachments[`${oldFileExtension}`]) {
                suffixOfAttachments[`${oldFileExtension}`] =
                    suffixOfAttachments[`${oldFileExtension}`] + 1;
            } else {
                suffixOfAttachments[`${oldFileExtension}`] = 1;
            }
            let fileDto = {
                fileUrl: fileInfo.fileUrl,
                fileSize: fileInfo.fileSize,
                fileName: fileInfo.fileName,
                isPdf: fileInfo.isPdf,
                splitPdf: fileInfo.splitPdf,
                createdAt: fileInfo.createdAt
            };
            if (fileDto.isPdf) {
                fileDto.isCreatingPageKnowledge = fileInfo.isCreatingPageKnowledge;
            }
            listFileUploadSuccess.push(fileDto);
        }
    });

    return {
        suffixOfAttachments: suffixOfAttachments,
        listFileUploadSuccess: listFileUploadSuccess
    };
};
